export const READ_ACTION = "READ";
export const LIST_ACTION = "LIST";
export const CREATE_ACTION = "CREATE";
export const UPDATE_ACTION = "UPDATE";
export const DESTROY_ACTION = "DESTROY";

export const EXPORT_ACTION = "EXPORT";
export const IMPORT_ACTION = "IMPORT";
